module.exports = __webpack_public_path__ + "img/righteous-resolutions.7a1e0acc.png";